import { SupabaseService } from "../../../../server/supabase/base-supabase-service";

import type { Database } from "../../../../__definitions__/database-definitions";

export type CustomEmailDomain = Database["public"]["Tables"]["custom_email_domain"]["Row"];

export class SupabaseCustomEmailDomainService extends SupabaseService<"custom_email_domain"> {
  table = "custom_email_domain" as const;
}
